import { useState } from "react";
import { CalendarPlus } from "lucide-react";
import { Sheet, SheetContent, SheetHeader, SheetTitle } from "./ui/sheet";
import { API } from "../lib/api";
import { useApp } from "../context/AppContext";

const compact = (d, t) => d.replace(/-/g, "") + (t ? `T${t.replace(":", "")}00` : "");
const nextDay = (d) => {
  const x = new Date(d + "T12:00:00");
  x.setDate(x.getDate() + 1);
  return x.toISOString().slice(0, 10);
};

export function AddToCalendar({ title, date, start, end, query, small }) {
  const { sp } = useApp();
  const [open, setOpen] = useState(false);
  const timed = start && end;
  const dates = timed ? `${compact(date, start)}/${compact(date, end)}` : `${compact(date)}/${compact(nextDay(date))}`;
  const google = `https://calendar.google.com/calendar/render?action=TEMPLATE&text=${encodeURIComponent(title)}&dates=${dates}${timed ? "&ctz=Europe/Brussels" : ""}`;
  const ics = `${API}${sp(`/ics?${query}`)}`;
  return (
    <>
      <button onClick={(e) => { e.preventDefault(); e.stopPropagation(); setOpen(true); }} data-testid="add-to-calendar-btn"
        className={small ? "flex items-center gap-1 rounded-lg px-2 py-2 text-xs font-bold text-teal-700 hover:bg-teal-50" : "btn-soft w-full"}>
        <CalendarPlus className="h-4 w-4" /> {small ? "Agenda" : "Ajouter à mon agenda"}
      </button>
      <Sheet open={open} onOpenChange={setOpen}>
        <SheetContent side="bottom" className="rounded-t-3xl bg-white" data-testid="calendar-sheet">
          <SheetHeader className="text-left"><SheetTitle className="font-display">Ajouter à mon agenda</SheetTitle></SheetHeader>
          <div className="mt-5 grid gap-3 pb-4">
            <a href={ics} className="btn-primary" data-testid="calendar-ics-link" onClick={() => setOpen(false)}>iPhone / Outlook / autres</a>
            <a href={google} target="_blank" rel="noreferrer" className="btn-ghost" data-testid="calendar-google-link" onClick={() => setOpen(false)}>Google Agenda</a>
          </div>
        </SheetContent>
      </Sheet>
    </>
  );
}
